import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SurveyComponent } from './survey.component';

const routes: Routes = [
  {
    path: ':id',
    component: SurveyComponent,
    data: {
      title: 'Tevredenheidsonderzoek',
    }
  },
  {
    path: ':id/:score',
    component: SurveyComponent,
    data: {
      title: 'Tevredenheidsonderzoek',
    }
  },
  {
    path: '**',
    component: SurveyComponent,
    data: {
      title: 'Tevredenheidsonderzoek',
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SurveyRoutingModule {
}
